<template>
	<v-list class="py-4 list">
		<v-text-field
			v-model="searchValue"
			@click.stop.prevent
			@input="(name) => getUsers(name)"
			placeholder="Szukaj..."
			outlined
			dense
			prepend-inner-icon="mdi-magnify"
			hide-details
			class="mx-4"
		></v-text-field>

		<v-divider class="my-4 mx-4" />

		<Transition name="fade">
			<div v-if="users">
				<v-list-item
					@click="selectUser(user)"
					:key="user.id"
					v-for="user in users"
					link
					class="d-flex"
				>
					<user-select :user="user" />
				</v-list-item>
			</div>
		</Transition>

		<div v-if="!users" class="d-flex justify-center align-center">
			<v-progress-circular indeterminate color="accent" />
		</div>
	</v-list>
</template>
<script>
import axios from "axios";

import UserSelect from "@/components/tasks/UserSelect.vue";

export default {
	components: {
		UserSelect,
	},
	data() {
		return {
			searchValue: "",
			users: "",
			selectedUser: "",
		};
	},
	methods: {
		async getUsers() {
			await axios
				.get("users/company", {
					params: { name: this.searchValue },
				})
				.then((response) => {
					this.users = response.data.data;
				})
				.catch((e) => {
					console.log("GET USER ERROR", e);
				});
		},

		selectUser(user) {
			this.selectedUser = user;
			this.$emit("selectUser", user.id);
		},
	},
	created() {
		this.selectedUser = this.$store.state.auth.user;
		this.getUsers();
	},
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.8s;
}
.fade-enter,
.fade-leave-to {
	opacity: 0;
}

.list {
	max-height: 300px;
}

.v-menu__content.v-menu__content--fixed.menuable__content__active {
	background-color: var(--v-background-lighten1) !important;
}
</style>
